import React from 'react'
import { Chip } from '@walmart-web/livingdesign-components'
import PropTypes from 'prop-types'

import LazyLoadImageContainer from '../../../components/LazyLoadImageContainer'
import { capitalizeWord } from '../../../Helpers'
import './ChipImage.css'

const ChipImage = ({
  product,
  primaryAttribute,
  primaryVariant,
  secondaryVariant,
  variantUrlImg,
  handleVariantClick,
  disabled,
}) => {
  const capitalizedPrimaryAttribute = capitalizeWord(primaryAttribute)
  return (
    <Chip
      UNSAFE_className={`chip-image__chip-container ${disabled ? 'chip-image__chip-container--disabled' : ''}`}
      selected={primaryVariant[primaryAttribute] === product.attributes[`sku${capitalizedPrimaryAttribute}`]}
      disabled={disabled}
      onClick={() => handleVariantClick({ variantSelected: secondaryVariant, [primaryAttribute]: primaryVariant })}
    >
      <LazyLoadImageContainer
        id="lazy-img"
        className="img-fluid m-auto chip-image__image-container--default"
        alt={secondaryVariant.sku}
        sku={secondaryVariant.sku}
        hitImage={variantUrlImg}
      />
    </Chip>
  )
}

ChipImage.defaultProps = {
  disabled: false,
}

ChipImage.propTypes = {
  product: PropTypes.object.isRequired,
  primaryAttribute: PropTypes.string.isRequired,
  variantUrlImg: PropTypes.string.isRequired,
  primaryVariant: PropTypes.object.isRequired,
  secondaryVariant: PropTypes.object.isRequired,
  handleVariantClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default ChipImage
